module.exports = __webpack_public_path__ + "static/media/members-illustration--cropped@1x.ba274e90.png";